<template>
  <Modal
    v-model="_value"
    width="900"
    title="设置权限"
    @on-visible-change="visibleChange"
    ok-text="修改"
    @on-ok="onOk">
    <Row>
      <div>
        <label>当前角色ID：{{roleInfo.id}} 角色名：{{roleInfo.name}} 昵称：{{roleInfo.nickName}}</label>
      </div>
    </Row>
    <Row style="margin-top: 10px;">
      <Tree ref="permissionTreeRef" :data="permissionTree" show-checkbox multiple></Tree>
    </Row>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'SetPermissionModal1',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      allPermissions: [],
      ownPermissions: [],
      moduleNames: [],
      permissionTree: [{
        title: '系统权限',
        expand: true,
        selected: false,
        children: []
      }],
      listStyle: {
        width: '400px'
      },
      roleId: null,
      roleInfo: {
        id: null,
        name: null,
        nickName: null,
        permissions: []
      }
    }
  },
  methods: {
    ...mapActions([
      'RoleServ_SetPermissions',
      'PermissionServ_GetAll',
      'UserServ_GetDetail',
      'PermissionServ_GetSystemModuleNames'
    ]),
    onChange (newTargetKeys, direction, moveKeys) {
      this.ownPermissions = newTargetKeys
    },
    onOk () {
      let permissions = []
      // permissions = this.ownPermissions.map(item => {
      //   return parseInt(item)
      // })
      let checkedNodes = this.$refs.permissionTreeRef.getCheckedNodes()
      if (checkedNodes) {
        checkedNodes.forEach(item => {
          if (item.id) {
            permissions.push(item.id)
          }
        })
      }
      store.dispatch('RoleServ_SetPermissions', {
        params: {
          roleId: this.roleId,
          permissionIds: permissions
        }
      }).then(() => {
        this.$Message.success('设置成功')
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    visibleChange (val) {
      if (val) {
        let roleId = this._initValue
        if (roleId) {
          this.roleId = roleId
          store.dispatch('PermissionServ_GetAll', {
            params: null,
            urlparams: { sort: genSortParam('moduleName', true) }
          }).then(() => {
            store.dispatch('RoleServ_GetDetail', {
              params: { id: roleId }
            }).then(() => {
              store.dispatch('PermissionServ_GetSystemModuleNames', {
                params: null
              }).then(() => {
                this.permissionTree = [{
                  title: '系统权限',
                  expand: true,
                  selected: false,
                  children: []
                }]
                this.roleInfo = store.getters.get_Role_GetDetailResult
                this.allPermissions = []
                this.ownPermissions = []
                this.moduleNames = store.getters.get_Permission_GetSystemModuleNamesResult
                this.moduleNames.forEach(item => {
                  this.permissionTree[0].children.push(
                    {
                      title: item,
                      expand: false,
                      selected: false,
                      children: []
                    }
                  )
                })
                this.roleInfo.permissions.forEach((item, index) => {
                  this.ownPermissions.push(item.id.toString())
                })
                store.getters.get_Permission_GetAllResult.forEach((item, index) => {
                  Vue.set(item, 'key', item.id.toString())
                  this.allPermissions.push(item)
                })
                let moduleList = this.permissionTree[0].children
                this.allPermissions.forEach(item => {
                  for (let i = 0; i < moduleList.length; i++) {
                    if (moduleList[i].title === item.moduleName) {
                      let checked = false
                      for (let j = 0; j < this.ownPermissions.length; j++) {
                        if (this.ownPermissions[j] == item.id) {
                          checked = true
                          break
                        }
                      }
                      let p = {
                        id: item.id,
                        title: item.nickName,
                        expand: false,
                        selected: false,
                        checked: checked,
                        children: []
                      }
                      moduleList[i].children.push(p)
                      break
                    }
                  }
                })
              }).catch(err => {
                this.$Message.error(err)
              })
            }).catch(err => {
              this.$Message.error(err)
            })
          }).catch(err => {
            this.$Message.error(err)
          })
        }
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
